import { FC } from 'react';
import { useIntl } from 'react-intl';

import globalMessages from 'src/messages';
import { phoneLink } from 'src/utils/intlHelper';

import { CanaDreamEmailUrl } from 'src/constants';

import {
    ContactWrapper,
    ContactItem,
    ContactItemHeader,
    ColoredTrialMessage,
} from './Contact';
import { ContactItemContent } from './Footer';
import { EmailUsLink } from './Footer';
import msg from './footerMessages';

const ContactCA: FC = () => {
    const intl = useIntl();

    return (
        <ContactWrapper>
            <ContactItem>
                <ContactItemHeader>
                    <span>{intl.formatMessage(msg.footer.needHelp)}</span>
                </ContactItemHeader>
                <ContactItemContent>
                    <EmailUsLink
                        href={CanaDreamEmailUrl}
                        target="_blank"
                    >
                        {intl.formatMessage(msg.footer.emailUs)}
                    </EmailUsLink>
                </ContactItemContent> 
            </ContactItem>
            <ContactItem>
                <ContactItemHeader>
                    <span>
                        {intl.formatMessage(
                            globalMessages.phones.canaDreamTollFreePhone,
                        )}
                    </span>
                </ContactItemHeader>
                <ColoredTrialMessage>
                    <span>
                        {intl.formatMessage(
                            globalMessages.phones.canaDreamTollFreePhoneNumber,
                            {
                                a: phoneLink,
                            },
                        )}
                    </span>
                </ColoredTrialMessage>
            </ContactItem>
            <ContactItem>
                <ContactItemHeader>
                    <span>
                        {intl.formatMessage(
                            globalMessages.phones.canaDreamInternationalPhone,
                        )}
                    </span>
                </ContactItemHeader>
                <ColoredTrialMessage>
                    <span>
                        <span>
                            {intl.formatMessage(
                                globalMessages.phones
                                    .canaDreamInternationalPhoneNumber,
                                {
                                    a: phoneLink,
                                },
                            )}
                        </span>
                    </span>
                </ColoredTrialMessage>
            </ContactItem>
        </ContactWrapper>
    );
};

export default ContactCA;
